import User from './UserNewPage';

export default User;
